module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer047"
    }
  }, [_c('p', {
    staticClass: "pictures_structure-nxt",
    attrs: {
      "id": "calibre_pb_5"
    }
  }, [_c('span', {
    staticClass: "bold3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-chapter",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('span', {
    staticClass: "bold4"
  }, [_c('a', {
    staticClass: "calibre3",
    attrs: {
      "id": "_idTextAnchor018"
    }
  })]), _c('a', {
    staticClass: "calibre3",
    attrs: {
      "href": "#/OEBPS/ebook_split_002#_idTextAnchor000"
    }
  }, [_c('span', {
    staticClass: "bold4"
  }, [_vm._v("Welcome to the 7 Habits!"), _c('span', {
    staticClass: "calibre3",
    attrs: {
      "id": "_idTextAnchor019"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("Congratulations! You’ve made it to college. That’s great. Now your "), _c('span', {
    staticClass: "italic1"
  }, [_vm._v("next")]), _vm._v(" goal is to graduate. After all, you didn’t come all this way just to get in, right? You came to "), _c('span', {
    staticClass: "italic1"
  }, [_vm._v("finish")]), _vm._v(". For you, finishing might mean two years and an associate’s degree, four years and a bachelor’s degree, or six years and a master’s degree. Or…who knows? Maybe people will be calling you “doctor” in a "), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("few")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("years.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("Regardless of how long it takes, graduation will be a great day. But the path won’t be easy. College can feel a lot like a marathon. I remember coming home after my first day at college feeling completely overwhelmed. The campus was huge, I didn’t know anyone, and I wasn’t sure I could succ"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("eed")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("there.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("Starting college can be a shock, whether you’re eighteen or twenty-eight or eighty. Once you make that big step, life becomes "), _c('span', {
    staticClass: "italic1"
  }, [_vm._v("much")]), _vm._v(" more complicated, especially if you have a job and a family and money issues. So, what I’m here to do is to help you succeed, not only in college but als"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("o in")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "italic1"
  }, [_vm._v("life")])]), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("Let me tell you about my friend David, who started at a state college less than a year ago. He doesn’t want to just put on a cap and gown and march across a stage at some point. He wants to make the most out of school. He wants to learn from great thinkers, meet people from all over, expand his mind, and be well prepared for his future job. But he also wants to do it all "), _c('span', {
    staticClass: "bold3"
  }, [_vm._v("effectively")]), _vm._v(". He doesn’t want to fall behind, take longer than needed, or waste time and money. He wants to do"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v(" it")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("right.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("My guess is that you feel the same way. You’ve worked hard to get here, so now you want to do it right. So, how are you going to succeed in college? For starters, I’ve learned that successful college students have three things in common. First, a compelling reason for going to college. Second, solid academic skills. And third, effective life skills. These things make up what I call the "), _c('span', {
    staticClass: "italic1"
  }, [_vm._v("College Succes")]), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "italic1"
  }, [_vm._v("s")])]), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "italic1"
  })]), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "italic1"
  }, [_vm._v("Formula")])]), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_c('span', {
    staticClass: "italic1"
  }, [_vm._v("Why are you in college in the first place?")]), _vm._v(" If you have a burning “Why,” you’ll be far more likely to finish college. Take the example of Isaac, who grew up in a neighborhood where few students made it through high school. Rarely did anyone think of college. Every day he felt pressure to go down the route of gangs and crime, but, somehow, he caught a vision. “I wanted something different for my life,” he told me. Isaac saw college as his path to a better life. No one in his family had ever done it, and, when he shared his dream with his high school counselor, he was told he wouldn’t make it unless he had a sports scholarship or joined the military. When neither of those options panned out, Isaac refused to be stopped. At age eighteen, he left home to fend for himself, got a job, and immediately began setting aside a little cash for tuition. After four years and much personal discipline, he enrolled i"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("n")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("college.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("Today, Isaac is as committed as ever to graduating. His compelling "), _c('span', {
    staticClass: "italic1"
  }, [_vm._v("why")]), _vm._v("—to attain a better life—keeps him working hard and making sacrifices. I think these experiences will make his "), _c('span', {
    staticClass: "italic1"
  }, [_vm._v("why")]), _vm._v(" even more compelling "), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("over")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("time.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("That’s not the only thing you need. It’s just as important to know"), _c('span', {
    staticClass: "italic1"
  }, [_vm._v(" how")]), _vm._v(" to succeed in college as to know "), _c('span', {
    staticClass: "italic1"
  }, [_vm._v("why.")]), _vm._v(" For that, you need two sets of skills: academic skills and li"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("fe")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("skills.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("Academic skills include writing, reading, test-taking, studying, note-taking, critical thinking, researching, and presenting. Of course, you also have to know how to navigate the campus, use the library, get help from your professors, and use online resources. Some students already come to college with solid academic skills, while others need to develop them. Most colleges know this, so they set up academic support centers—most at no cost to you—for tutoring, mentoring, and testing. There are also lots of resources on the Internet. Many colleges have college success courses you can take that will help you build study skills and life skills. (You may even be using this e-book in one of these"), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("courses!)")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("If you haven’t developed good study skills, it’s not too late"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v(" to")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("start.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("Jeri had lousy study habits in high school. After two kids and a divorce, she decided to go back to school so she could qualify for a better job. That was when her study habits came back to haunt her. Reading in bed put her to sleep, and trying to study on the busy train to work was pointless. Then there was procrastination, a lifelong hobby for Jeri. Plus, the two kids were her darling little"), _c('span', {
    staticClass: "nobreak"
  }), _vm._v("dis"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("tractions.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("A few changes were in order. Jeri moved out of her bed into what she called her “study home,” a quiet corner where she could be alone for two hours a day after work. She used those hours for heavy reading and saved her train time for light reviews of what she had read. “When the kids are at daycare and I have the place to myself, I can study until my brain f"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("alls")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("out.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("As with Jeri, your study skills can make all the difference, and it’s your responsibility to develop them. No one can do i"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("t for")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("you.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("Finally, you need effective life skills—for managing time, setting goals, building friendships, caring for your health, working in teams, and so on. These are just as important as academic skills. You probably know students who are bright intellectually but struggle to get along with other people or manage their time and money. They might be smart, but they have a tough time making friends or holding on to a job. In fact, a critical reason for gaining life skills is that employers will always look for new hires who have soft skills like these. They obviously like to know you did well in your classes, but they also want to know if you’re disciplined and good with people. While most employers are willing to train you for your job, they don’t want to have to train you in li"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("fe")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("skills.")])]), _vm._v(" "), _c('p', {
    staticClass: "pictures_line"
  }, [_c('span', {
    staticClass: "toc-leader",
    attrs: {
      "id": "calibre_toc_5"
    }
  }, [_c('img', {
    staticClass: "_idgenobjectattribute1",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/1.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body_note"
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("DID")]), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v(" YOU")])]), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "bold2"
  })]), _c('span', {
    staticClass: "nobreak"
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("KNOW?")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_note"
  }, [_vm._v("Life Skills Make You"), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("Employable")])]), _vm._v(" "), _c('p', {
    staticClass: "body_note"
  }, [_vm._v("Edexcel, a United Kingdom-based education firm, recently asked more than two thousand employers from twenty-two countries what they look for when recruiting. They responded with pleas for more life skills"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v(", such")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("as:")])]), _vm._v(" "), _c('p', {
    staticClass: "body_notebullets"
  }, [_c('span', {
    staticClass: "_idgenbnmarker"
  }, [_vm._v("•")]), _vm._v("Probl"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("em")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("solving")])]), _vm._v(" "), _c('p', {
    staticClass: "body_notebullets"
  }, [_c('span', {
    staticClass: "_idgenbnmarker"
  }, [_vm._v("•")]), _vm._v("Positiv"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("thinking")])]), _vm._v(" "), _c('p', {
    staticClass: "body_notebullets"
  }, [_c('span', {
    staticClass: "_idgenbnmarker"
  }, [_vm._v("•")]), _vm._v("Creativity/"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("innovation")])]), _vm._v(" "), _c('p', {
    staticClass: "body_notebullets"
  }, [_c('span', {
    staticClass: "_idgenbnmarker"
  }, [_vm._v("•")]), _vm._v("Trust")]), _vm._v(" "), _c('p', {
    staticClass: "body_notebullets"
  }, [_c('span', {
    staticClass: "_idgenbnmarker"
  }, [_vm._v("•")]), _vm._v("Leadership and"), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("management")])]), _vm._v(" "), _c('p', {
    staticClass: "body_notebullets"
  }, [_c('span', {
    staticClass: "_idgenbnmarker"
  }, [_vm._v("•")]), _vm._v("Mu"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("ltitasking")])]), _vm._v(" "), _c('p', {
    staticClass: "body_notebullets"
  }, [_c('span', {
    staticClass: "_idgenbnmarker"
  }, [_vm._v("•")]), _vm._v("Initiative/resp"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("onsibility")])]), _vm._v(" "), _c('p', {
    staticClass: "body_notebullets"
  }, [_c('span', {
    staticClass: "_idgenbnmarker"
  }, [_vm._v("•")]), _vm._v("Teamwork")]), _vm._v(" "), _c('p', {
    staticClass: "body_notebullets"
  }, [_c('span', {
    staticClass: "_idgenbnmarker"
  }, [_vm._v("•")]), _vm._v("Empathy")]), _vm._v(" "), _c('p', {
    staticClass: "body_notebullets"
  }, [_c('span', {
    staticClass: "_idgenbnmarker"
  }, [_vm._v("•")]), _vm._v("Communicat"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("ion")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("skills")])]), _vm._v(" "), _c('p', {
    staticClass: "body_notebullets"
  }, [_c('span', {
    staticClass: "_idgenbnmarker"
  }, [_vm._v("•")]), _vm._v("Profession"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("al")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("manners")])]), _vm._v(" "), _c('p', {
    staticClass: "body_notebullets"
  }, [_c('span', {
    staticClass: "_idgenbnmarker"
  }, [_vm._v("•")]), _vm._v("Cultural"), _c('span', {
    staticClass: "nobreak"
  }), _vm._v("s"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("ensitivity")])]), _vm._v(" "), _c('p', {
    staticClass: "body_notebullets"
  }, [_c('span', {
    staticClass: "_idgenbnmarker"
  }, [_vm._v("•")]), _vm._v("Considering these life skills, how employable are you right now? What can you do to make yourself more"), _c('span', {
    staticClass: "nobreak"
  }), _vm._v("e"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("mployable?")])]), _vm._v(" "), _c('p', {
    staticClass: "pictures_line"
  }, [_c('span', {
    staticClass: "toc-leader",
    attrs: {
      "id": "calibre_toc_6"
    }
  }, [_c('img', {
    staticClass: "_idgenobjectattribute1",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/2.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("So how do you improve your life skills? It’s all about your habits. You might have habits that work against you, like procrastination or impulsiveness. (Why "), _c('span', {
    staticClass: "italic1"
  }, [_vm._v("did")]), _vm._v(" you eat all that pizza"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v(", anyway?)")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("You gain good life skills by changing your habits, especially if you have darker ones like"), _c('span', {
    staticClass: "nobreak"
  }), _vm._v("a"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("ddictions.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("The purpose of this e-book is to help you form "), _c('span', {
    staticClass: "italic1"
  }, [_vm._v("new")]), _vm._v(" habits—the habits of effective, successful students—that will help you lead a successful, effec"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("tive")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("life.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("This e-book is based on "), _c('span', {
    staticClass: "italic1"
  }, [_vm._v("The 7 Habits of Highly Effective People")]), _vm._v(", a set of life skills originally identified by my father, Dr. Stephen R. Covey. As a university professor, he spent decades studying the habits of the most successful people and organizations. He reviewed literally hundreds of books and mounds of research, drawing on sources from all over the world and from both classic and modern literature. After this academic odyssey, he started sharing the 7 Habits with his students at the university. His classes grew so popular that they started being held in the basketball arena. In 1989, the much-awaited book "), _c('span', {
    staticClass: "italic1"
  }, [_vm._v("The 7 Habits of Highly Effective People")]), _vm._v(" first came out. Over twenty-five million copies in forty different languages later, we’re bringing the 7 Habi"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("ts to")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("you.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("So, what are the 7 Habits of Highly Effective College"), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("Students?")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("The habits build on each other. When you were born, you were "), _c('span', {
    staticClass: "italic1"
  }, [_vm._v("dependent ")]), _vm._v("on your parents or others for your survival. Gradually, you started moving toward independence. So, Habit 1 is "), _c('span', {
    staticClass: "bold3"
  }, [_vm._v("Be Proactive")]), _vm._v(". That means taking responsibility for your own life. Habit 2 is "), _c('span', {
    staticClass: "bold3"
  }, [_vm._v("Begin with the End in Mind")]), _vm._v(", a. k. a deciding what your life is all about, what your mission in life is, and what your most cherished goals are. Habit 3, "), _c('span', {
    staticClass: "bold3"
  }, [_vm._v("Put First Things First")]), _vm._v(", is about making sure that the most important things in your life get priority. The more you live by these first 3 habits, the more "), _c('span', {
    staticClass: "italic1"
  }, [_vm._v("independent")]), _vm._v(" you become. We call it “winning the Private Victory” over"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v(" the")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("self.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("While it’s good to be independent, there is a higher state to strive for. This is called interdependence. At home, at school, at work, we must work well with others to be successful. Life is a team sport. Habit 4 is "), _c('span', {
    staticClass: "bold3"
  }, [_vm._v("Think Win-Win")]), _vm._v(", which means that you always act with consideration for the needs of others as well as your own needs. Habit 5 is "), _c('span', {
    staticClass: "bold3"
  }, [_vm._v("Seek First to Understand, Then to Be Understood")]), _vm._v(". It’s about the ability to see the world from the point of view of others before trying to make others see your point of view. Habit 6, "), _c('span', {
    staticClass: "bold3"
  }, [_vm._v("Synergize")]), _vm._v(", means that you actually appreciate different points of view because they broaden your own understanding and lead to better solutions. These three habits (4, 5, and 6) make you more "), _c('span', {
    staticClass: "italic1"
  }, [_vm._v("interdependent")]), _vm._v(". We call it “winning the Public"), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("Victory.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("So you move from "), _c('span', {
    staticClass: "italic1"
  }, [_vm._v("dependence")]), _vm._v(" to "), _c('span', {
    staticClass: "italic1"
  }, [_vm._v("independence")]), _vm._v(" to "), _c('span', {
    staticClass: "italic1"
  }, [_vm._v("interdependence")]), _vm._v(". The more interdependent you are, the more you become a leader—a leader of your own life and a leader among y"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("our")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("peers.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("Habit 7, "), _c('span', {
    staticClass: "bold3"
  }, [_vm._v("Sharpen the Saw")]), _vm._v(", nourishes all the other habits. It’s the practice of "), _c('span', {
    staticClass: "italic1"
  }, [_vm._v("renewal")]), _vm._v(". If you exercise Habit 7, you do something every day to recharge your body, mind, spirit, and emotional life. You can’t practice the other habits unless you practic"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("e Habit")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("7.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("The 7 Habits are the key, not only to success in college, but also to success in "), _c('span', {
    staticClass: "italic1"
  }, [_vm._v("life")]), _vm._v(". (In this e-book, we’re going to mainly focus on using the 7 Habits for univers"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("ity")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("life.)")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("College is "), _c('span', {
    staticClass: "italic1"
  }, [_vm._v("meant")]), _vm._v(" to stretch your mind, abilities, and grow your expertise. The first year is often the hardest. So don’t be alarmed if you have an occasional overwhelming day or bomb a test here or there. If for whatever reason, you find yourself facing more than you can handle academically, financially, or emotionally, then seek help. But whatever you do, d"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("on’t")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("quit!")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("My hope is that you’ll have the time of your life while in college. Trust me, in spite of the occasional marathon-like moment, college can truly be a lot of fun and incredibly worth your investments of money, time, and effort. There are good reasons why so many people, including myself, think back on their college years as some of the best. And they are not just thinking of the parties. They made lifetime friends, learned from great minds, overcame insecurities, had a lot of fun, and prepared themselves for meaningful careers. They’re even grateful for the challenges they faced that made them"), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("stronger.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("So, yes, welcome t"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("o")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("college!")])]), _vm._v(" "), _c('p', {
    staticClass: "pictures_line"
  }, [_c('span', {
    staticClass: "toc-leader",
    attrs: {
      "id": "calibre_toc_7"
    }
  }, [_c('img', {
    staticClass: "_idgenobjectattribute1",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/2.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body_note"
  }, [_vm._v("In the next chapter, you’ll discover the secret to not just surviving but "), _c('span', {
    staticClass: "italic2"
  }, [_vm._v("thriving")]), _vm._v(" in college. It’s all about the principles that successful college students—and successful peopl"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("e—live")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("by.")])]), _vm._v(" "), _c('p', {
    staticClass: "pictures_line1",
    attrs: {
      "id": "calibre_pb_6"
    }
  }, [_c('span', {
    staticClass: "toc-leader",
    attrs: {
      "id": "calibre_toc_8"
    }
  }, [_c('img', {
    staticClass: "_idgenobjectattribute1",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/2.png"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74053e67","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ebook_split_003.vue
// module id = 66
// module chunks = 0